// Libraries
import React from 'react';
import { useContext, useEffect, useState, useRef } from 'react';

// Relative imports
import './stepone.component.css';
import StepOneManual from './stepone_manual_entry/stepone_manual.component';
import StepOneFileUpload from './stepone_file_upload/stepone_file_upload.component';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import AppContext from '../../../context';

const usePrevious = (noOfTxs) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = noOfTxs.length;
  });
  return ref.current;
};

const StepOne = (props) => {
  const context = useContext(AppContext);
  const [tableContHeight, setTableContHeight] = useState(null);
  const [searchDropdownPos, setSearchDropdownPos] = useState({});
  const [typeDropdownPos, setTypeDropdownPos] = useState({});
  const prevTxsLength = usePrevious(props.txs);
  const containerRef = useRef(null);
  const tableContainerRef = useRef(null);
  const searchBarRef = useRef(null);
  const typeSelectRef = useRef(null);
  let debounce;
  const [parsedTxsLength, setParsedTxsLength] = useState({});

  const getSetDropdownsPosition = () => {
    let searchDropdownPos = {};
    let typeDropdownPos = {};
    const modalBody =
      containerRef.current.parentElement.getBoundingClientRect();
    // search input
    const searchBarPos = searchBarRef.current.getBoundingClientRect();
    const searchBarWidth = searchBarPos.width;
    searchDropdownPos['width'] = searchBarWidth;
    searchDropdownPos['left'] = searchBarPos.left;
    // tx type input
    const typeInputPos = typeSelectRef.current.getBoundingClientRect();
    const typeInputWidth = typeInputPos.width;
    typeDropdownPos['width'] = typeInputWidth;
    typeDropdownPos['left'] = typeInputPos.left;

    const spaceAvail = modalBody.bottom - searchBarPos.bottom;
    spaceAvail > 160
      ? (searchDropdownPos['top'] = searchBarPos.bottom)
      : (searchDropdownPos['bottom'] = window.innerHeight - searchBarPos.top);
    spaceAvail > 100
      ? (typeDropdownPos['top'] = typeInputPos.bottom)
      : (typeDropdownPos['bottom'] =
          window.innerHeight - typeInputPos.top - 16);
    setSearchDropdownPos(searchDropdownPos);
    setTypeDropdownPos(typeDropdownPos);
  };

  const handleTableScroll = () => {
    if (props.isManual) {
      debounce = setTimeout(() => getSetDropdownsPosition(0), 300);
    }
    return;
  };

  const clearTxs = () => {
    props.setTxs([]);
    props.setBsdTxs([]);
    props.setInvalidComps([]);
    props.setTxsFincode([]);
    if (!props.isManual) {
      props.setErroredBsdTxs(null);
      props.setShowErroredBsdTxs(false);
    }
  };

  const popover = () => (
    <Popover>
      <Popover.Content>
        <div className="py-2">
          Are you sure you want to clear all added Transactions?
        </div>
        <div>
          <Button
            variant="danger"
            className="confirm-tx-btn"
            onClick={() => {
              clearTxs();
              document.body.click();
            }}
          >
            Clear
          </Button>
          <Button
            variant="secondary"
            className="confirm-tx-btn cancel-btn"
            onClick={() => document.body.click()}
          >
            Cancel
          </Button>
        </div>
      </Popover.Content>
    </Popover>
  );

  useEffect(() => {
    if (props.txs.length !== prevTxsLength && props.isManual) {
      setTimeout(() => getSetDropdownsPosition());
    }
  }, [props.txs]);

  const getTabClass = (tabType) => {
    if (props.txs.length) {
      if (tabType === 'manual') {
        return !props.isManual ? 'disabled' : 'active';
      } else {
        return props.isManual ? 'disabled' : 'active';
      }
    } else {
      if (tabType === 'manual') {
        return props.isManual ? 'active' : '';
      } else {
        return !props.isManual ? 'active' : '';
      }
    }
  };

  useEffect(() => {
    return () => clearTimeout(debounce);
  }, []);

  useEffect(() => {
    if (props.invalidComps.length) {
      props.setInvalidComps([]);
    }
    if (props.isManual && parsedTxsLength.valid === 0) {
      setParsedTxsLength({});
    }
  }, [props.isManual]);

  return (
    <>
      <div id="calendar-portal"></div>
      <div
        ref={containerRef}
        className="add-tx-content px-md-5 pt-md-5 px-sm-4 pt-sm-4 px-4 pt-4"
      >
        <div className="add-tx-header position-relative">
          <span className="step-text">{props.pfName}</span>
          <h5 className="step-heading pt-1">ADD AN INVESTMENT</h5>
          <ul className="add-tx-nav">
            <li
              className={getTabClass('manual')}
              onClick={() => props.setIsManual(true)}
            >
              Manual Entry
            </li>
            <li
              className={getTabClass('file_upload')}
              onClick={() => props.setIsManual(false)}
            >
              Excel Upload
            </li>
          </ul>
          <hr></hr>
          {props.txs.length > 0 && (
            <OverlayTrigger
              trigger="click"
              placement="left"
              overlay={popover()}
              rootClose
              className="shadow"
            >
              <Button size="sm" variant="" className="addTx-clear">
                Clear all Transactions
              </Button>
            </OverlayTrigger>
          )}
        </div>
        <div
          className={`add-tx-table-container position-relative overflow-auto flex-grow`}
          onScroll={handleTableScroll}
          ref={tableContainerRef}
        >
          {props.isManual ? (
            <StepOneManual
              setStep={props.setStep}
              setTxs={props.setTxs}
              txs={props.txs}
              setBsdTxs={props.setBsdTxs}
              removeTx={props.removeTx}
              txsFincode={props.txsFincode}
              setTxsFincode={props.setTxsFincode}
              containerRef={containerRef}
              ref={{ searchBarRef, typeSelectRef }}
              searchDropdownPos={searchDropdownPos}
              typeDropdownPos={typeDropdownPos}
              isManual={props.isManual}
              invalidComps={props.invalidComps}
              isLoaderVisible={props.isLoaderVisible}
            />
          ) : (
            <StepOneFileUpload
              setTxs={props.setTxs}
              txs={props.txs}
              removeTx={props.removeTx}
              txsFincode={props.txsFincode}
              setTxsFincode={props.setTxsFincode}
              containerRef={containerRef}
              isManual={props.isManual}
              setParsedTxsLength={setParsedTxsLength}
              parsedTxsLength={parsedTxsLength}
              invalidComps={props.invalidComps}
              tableContainerRef={tableContainerRef}
              isLoaderVisible={props.isLoaderVisible}
              erroredBsdTxs={props.erroredBsdTxs}
              showErroredBsdTxs={props.showErroredBsdTxs}
              setFileUploadTemplate={props.setFileUploadTemplate}
              pfId={props.pfId}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default StepOne;
